import React from 'react';
import { Helmet } from "react-helmet";
const AboutUs = () => {
    return (
        <div className="flex justify-center items-center mt-4 mb-3">
            <Helmet>
                <title>Disclaimer Tecom</title>
            </Helmet>
            <div className=" max-w-lg bg-white shadow-lg rounded-lg overflow-hidden">
                <div className="px-6 py-4">
                    <div className="font-bold text-xl mb-2">Disclaimer</div>
                    <div className="mb-4">
                        <h2 className="text-lg font-bold mb-2">Media disclaimer</h2>
                        <ul className="list-disc pl-6">
                            <li>Information provided by Tecom is for informational purposes only, without warranties or guarantees. Consult our technical experts before any transactions. Tecom does not offer media consulting, broadcasting advice, or software brokerage. Our information does not constitute personal advice or recommendations for purchasing broadcasting software or digital products. Tecom does not guarantee the reasonableness or suitability of any digital software.</li>
                        </ul>
                    </div>
                    <div className="mb-4">
                        <h2 className="text-lg font-bold mb-2">Software Disclaimer</h2>
                        <ul className="list-disc pl-6">
                            <li>Tecom provides broadcasting software information 'as is,' without warranties regarding accuracy or suitability. We offer information without endorsing specific products. Users are advised to consult our experts before making decisions. Tecom is not liable for outcomes resulting from such information use or product selection.</li>
                        </ul>
                    </div>
                    <div>
                        <h2 className="text-lg font-bold ">Hardware disclaimer</h2>
                        <ul className="list-disc pl-6">
                            <li>Tecom offers broadcasting hardware information without warranties on accuracy or suitability. While we aim to assist users, we do not endorse specific products. Consult our experts before selecting transmission and physical data relay equipment. Tecom disclaims responsibility for any outcomes from this information use.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutUs;
